import React, { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import RecepcionHeaderEstadoDXdia from "./Componentes/HeaderDatosEstadoDXdia";
import DataTable from 'react-data-table-component';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import FormatDate from '../Utils/FormatDate';
import { useAuth } from '../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from './../Utils/BotonVerAtencionesPersona';
import CargandoSpinner from '../Utils/CargandoSpinner';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import { isNumeric } from 'validator';

export default function Recepciondx() {
  const { token, rol, sedeActual } = useAuth();
  const [Cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const [listaRecepcionPersonas, setListaRecepcionPersonas] = useState([]);
  const [cantidadManual, setCantidadManual] = useState(0);
  const [sedes, setSedes] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(sedeActual);
  const [profesionales, setProfesionales] = useState([]);
  const [datosFecha, setDatosFecha] = useState({
      familiasdia: '0',
      familiaspendientes: '0',
      familiasenatencion: '0',
      familiasatendidas: '0',
      familiasbloqueadas: '0',
      familiasanuladas: '0'
  });
  const [filters, setFilters] = useState({
    identificacion: '',
    primerNombre: '',
    primerApellido: '',
    profesional: '',
    estado: '',
    sede: '',
    municipio: '',
    rep_entorno: '',
  });
  const filteredData = listaRecepcionPersonas.filter(row => {
    return (
      (row.rep_identificacion || '').toLowerCase().includes(filters.identificacion.toLowerCase()) &&
      (row.rep_primernombre || '').toLowerCase().includes(filters.primerNombre.toLowerCase()) &&
      (row.rep_primerapellido || '').toLowerCase().includes(filters.primerApellido.toLowerCase()) &&
      (row.profesionalatencion || '').toLowerCase().includes(filters.profesional.toLowerCase()) &&
      (row.estadoatencion || '').toLowerCase().includes(filters.estado.toLowerCase()) &&
      (row.nombresede || '').toLowerCase().includes(filters.sede.toLowerCase()) &&
      (row.municipio || '').toLowerCase().includes((filters.municipio || '').toLowerCase()) &&
      (row.rep_entorno || '').toLowerCase().includes((filters.rep_entorno || '').toLowerCase())
    );
  });
  function ActualizarCantidadManual(e) {
    let cantidad = e.target.value;
    if (!isNumeric(cantidad) || cantidad <= 0) {
      cantidad = 0;
    }
    setCantidadManual(cantidad);
    const url = '/diagnostico/recepcion/actualizarcantidadfichosdia';
    const obj = { cantidad: cantidad, sede: sedeActual };
    apiService.post(url, obj, token)
      .then(response => {
        const result = response.data;
        if (result.success) {
          setSwalProps({
            title: 'Cantidad actualizada',
            text: `Cantidad manual actualizada a ${cantidad}`,
            icon: 'success'
          });
        } else {
          setSwalProps({
            title: 'Error',
            text: result.message,
            icon: 'error'
          });
        }
      })
      .catch(error => {
        console.error('Error updating quantity:', error);
        setSwalProps({
          title: 'Error',
          text: 'No se pudo actualizar la cantidad manual',
          icon: 'error'
        });
      });
  }
  const fetchData = async () => {
    const now = new Date();
    const url = '/diagnostico/recepcion/personasporfecha';
    const obj = { rolid: rol, fecha: FormatDate(now), sede: sedeActual}
    try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setListaRecepcionPersonas(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setCargando(false);
    }
  };
  const ConsultarSedes = async () => {
    const url = '/diagnostico/recepcion/listarsedes';
    try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setSedes(result);
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setCargando(false);
    }
  };

  async function estoes (action) {
    debugger
    if (typeof action === 'object' && action !== null && action.id) {
        action = action.id;
    }
    DatosRecepcionFecha(action)
  }

  const DatosRecepcionFecha = async (sede) => {
    const url = '/diagnostico/recepcion/datosfecha';
    const obj = { sede: Number.parseInt(sede)}
    try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setProfesionales(result.profesionales || []);
          if (Array.isArray(result.result) && result.result.length > 0) {
            setDatosFecha(result.result[0]);
          } else {
          setDatosFecha({
            familiasdia: '0',
            familiaspendientes: '0',
            familiasenatencion: '0',
            familiasatendidas: '0',
            familiasbloqueadas: '0',
            familiasanuladas: '0'
          });
          }
          setSedeSeleccionada(sede);
        
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setCargando(false);
    }
  };
  function ConsultarfichosDia(sede) {
    const url = '/diagnostico/recepcion/consultarcantidadfichosdia';
    const obj = { sede: Number.parseInt(sede) }
    apiService.post(url, obj, token)
      .then(response => {
        const result = response.data;
        if (response.status === 200) {
          setCantidadManual(result.ficConstanciasrecibidas);
        } else {
          setSwalProps({
            title: 'Error',
            text: result.message,
            icon: 'error'
          });
        }
      })
      .catch(error => {
        console.error('Error fetching fichos:', error);
        setSwalProps({
          title: 'Error',
          text: 'No se pudo obtener la cantidad de fichos del día',
          icon: 'error'
        });
      });
  }
  useEffect(() => {
    ConsultarfichosDia(sedeActual)
    ConsultarSedes();
    DatosRecepcionFecha(sedeActual);
    fetchData();
    
  }, [sedeActual]);

  const ActualizarLista = async () =>  {
    await fetchData();
  }

  const AbrirFormularioRecepcion = (row) =>  {
    navigate(`/dx/crearrecepcionpersona/${row.id}/${sedeActual}`);
  };
  function verAtencionPersona (row){
            return <BotonVerAtencionesPersona verAtencionesPersona={AbrirFormularioRecepcion} row={row} text={'Ver recepción'} />
        }
  return (
      <div className="content-wrapper">
          <SeccionPageHeader 
            title="Recepción diagnostico base"
            idCabezaFamilia="0"
            url=""
            nombreurl="Recepción dx"
            nombreform="Crear"
            />
          <CargandoSpinner Cargando={Cargando}/>
          <section className="content">
            <div className="container-fluid">
              <div className='card' style={{ marginBottom: '10px', padding: '10px' }}>
                <RecepcionHeaderEstadoDXdia 
                    datosFecha={datosFecha} 
                    sedes={sedes} 
                    actionSedes={estoes}
                    AbrirFormularioRecepcion= {AbrirFormularioRecepcion}
                    sedeActual = {sedeSeleccionada}
                    showSelectSede={rol === '2'}
                    cantidadManual={cantidadManual}
                    ActualizarCantidadManual={ActualizarCantidadManual}
                    Profesionales={profesionales}
                  />
              </div>
              <div className="card card">
                  <div className="card-body">
                      <div className="card-body table-responsive p-0">
                          <button type="button" className='form-control' onClick={ActualizarLista}>Actualizar lista</button>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm">
                              <thead className="thead-light">
                                <tr>
                                  <th>Acciones</th>
                                  <th>Ficho</th>
                                  <th>Identificación</th>
                                  <th>Primer nombre</th>
                                  <th>Segundo nombre</th>
                                  <th>Primer apellido</th>
                                  <th>Segundo apellido</th>
                                  <th>Prioridad</th>
                                  <th>Lugar del hecho</th>
                                  <th>Entorno</th>
                                  <th>Profesional</th>
                                  <th>Hora recepción</th>
                                  <th>Estado</th>
                                  <th>Sede</th>
                                  <th>Hora atención</th>
                                </tr>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.identificacion}
                                      onChange={e => setFilters(f => ({ ...f, identificacion: e.target.value }))}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.primerNombre}
                                      onChange={e => setFilters(f => ({ ...f, primerNombre: e.target.value }))}
                                    />
                                  </th>
                                  <th></th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.primerApellido}
                                      onChange={e => setFilters(f => ({ ...f, primerApellido: e.target.value }))}
                                    />
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.municipio || ""}
                                      onChange={e => setFilters(f => ({ ...f, municipio: e.target.value }))}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.rep_entorno || ""}
                                      onChange={e => setFilters(f => ({ ...f, rep_entorno: e.target.value }))}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.profesional}
                                      onChange={e => setFilters(f => ({ ...f, profesional: e.target.value }))}
                                    />
                                  </th>
                                  <th></th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.estado}
                                      onChange={e => setFilters(f => ({ ...f, estado: e.target.value }))}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Filtrar"
                                      value={filters.sede}
                                      onChange={e => setFilters(f => ({ ...f, sede: e.target.value }))}
                                    />
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredData.length === 0 && (
                                  <tr>
                                    <td colSpan={15} className="text-center">No hay datos para mostrar</td>
                                  </tr>
                                )}
                                {filteredData.map((row) => (
                                  <tr key={row.id}>
                                    <td>{verAtencionPersona(row)}</td>
                                    <td>{row.rep_fichodia}</td>
                                    <td>{row.rep_identificacion}</td>
                                    <td>{row.rep_primernombre}</td>
                                    <td>{row.rep_segundonombre}</td>
                                    <td>{row.rep_primerapellido}</td>
                                    <td>{row.rep_segundoapellido}</td>
                                    <td>{row.rep_prioridad}</td>
                                    <td>{row.municipio}</td>
                                    <td>{row.rep_entorno}</td>
                                    <td>{row.profesionalatencion}</td>
                                    <td>{row.rep_fechahorarecepcion ? row.rep_fechahorarecepcion.split('T')[1].split('.')[0] : ''}</td>
                                    <td>{row.estadoatencion}</td>
                                    <td>{row.nombresede}</td>
                                    <td>{row.rep_fechahoraatencion ? row.rep_fechahoraatencion.split('T')[1].split('.')[0] : ''}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>                          
                      </div>
                  </div>
              </div>
              
              {/* /.Form reception */}
              <div id="divlistaDxAnteriores" className="table-responsive">
                <table id="tblDxAnterioresPersona" className="table table-condensed table-hover">
                </table>
              </div>             
              
              
                
            </div>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
          </section>
          
      </div>
      
  )
  }